import { Button, Chip } from "@mui/material";

const FilterwiseButton = ({
  statusFilter,
  statusOptions,
  onStatusFilterChange,
}) => {
  return (
    <>
      {statusOptions.map((option) => (
        <Button
          key={option.value}
          variant={statusFilter === option.value ? "contained" : "outlined"}
          onClick={() =>
            onStatusFilterChange && onStatusFilterChange(option.value)
          }
          className="poppins-font"
          sx={{
            borderRadius: 5,
            minWidth: "auto",
            px: { xs: 0.7, sm: 1.2 },
            py: { xs: 0.5, sm: 0.8 },
            fontWeight: 500,
            fontSize: { xs: "0.45rem", sm: "0.80rem" }, // smaller font
            border:
              statusFilter === option.value
                ? `2px solid ${option.color}`
                : "2px solid #e5e7eb",
            background: "#fff",
            color: statusFilter === option.value ? option.color : "#222",
            opacity: 1,
            boxShadow:
              statusFilter === option.value ? `0 0 0 2px ${option.color}22` : 0,
            transition: "all 0.2s",
            "&:hover": {
              border: `2px solid ${option.color}`,
              color: option.color,
              background: "#fff",
            },
            display: "flex",
            alignItems: "center",
            gap: { xs: 0.5, sm: 1.2 },
            flexShrink: 0,
            lineHeight: 1.1,
          }}
        >
          <span
            style={{
              fontWeight: 500,
              color: statusFilter === option.value ? option.color : "#222",
              background: "transparent",
              fontSize: "0.75em", // smaller font
              letterSpacing: 1,
            }}
          >
            {option.label}
          </span>
          <Chip
            label={option.count}
            sx={{
              ml: 0.5,
              background: "#f3f4f6",
              color: "#6b7280",
              fontWeight: 500,
              boxShadow: "none",
              fontSize: { xs: "0.40rem", sm: "0.60rem" }, // smaller font
              height: { xs: 13, sm: 18 }, // smaller chip
              px: { xs: 0.3, sm: 0.7 },
            }}
          />
        </Button>
      ))}
    </>
  );
};

export default FilterwiseButton;
